import script from "./TableHeaderHospitalBillAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderHospitalBillAdd.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderHospitalBillAdd.vue?vue&type=style&index=0&id=579ae791&lang=css"

const __exports__ = script;

export default __exports__